import React, { useRef, useState } from "react"
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap"

// Da a una tabla un boton "Maximizar" que la abre en un modal a pantalla
// completa. `children` es una funcion (enModal) => nodo: se llama con false para
// la version inline y con true para la del modal (con otro testId y estado
// propio). Cada instancia de MaximizarTabla mantiene su estado abierto/cerrado.
// reactstrap resuelve Esc, click fuera, aria-modal, role=dialog y foco atrapado;
// el retorno del foco al boton que lo abrio se asegura en onClosed.
const MaximizarTabla = ({ titulo, testId = "tabla", children }) => {
  const [abierto, setAbierto] = useState(false)
  const botonRef = useRef(null)
  const nombre = titulo || "importaciones"
  const idTitulo = `${testId}-max-titulo`
  const cerrar = () => setAbierto(false)

  return (
    <div data-testid={`${testId}-maximizable`}>
      <div className="d-flex justify-content-end mb-1">
        <Button
          innerRef={botonRef}
          type="button"
          color="light"
          size="sm"
          aria-label={`Maximizar tabla ${nombre}`}
          title="Maximizar"
          data-testid={`${testId}-maximizar`}
          onClick={() => setAbierto(true)}
        >
          <i className="mdi mdi-arrow-expand-all me-1" aria-hidden="true" />
          Maximizar
        </Button>
      </div>
      {children(false)}
      <Modal
        isOpen={abierto}
        fullscreen
        size="xl"
        fade={false}
        keyboard
        backdrop
        toggle={cerrar}
        labelledBy={idTitulo}
        returnFocusAfterClose
        onClosed={() => botonRef.current?.focus()}
      >
        <ModalHeader toggle={cerrar} close={<span />}>
          <span id={idTitulo}>{nombre}</span>
          <Button
            type="button"
            color="secondary"
            size="sm"
            className="ms-3"
            data-testid={`${testId}-cerrar`}
            onClick={cerrar}
          >
            Cerrar
          </Button>
        </ModalHeader>
        <ModalBody>{abierto && children(true)}</ModalBody>
      </Modal>
    </div>
  )
}

export default MaximizarTabla
